export default __webpack_public_path__ + "static/media/101t.1498a486.jpg";